import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgenteAsignarDo = async (credentials, data) => {
  const body = {
    service: "RNHAgenteAsignarDo",
    params: {
      rnhAgenteId: data?.agenteId || null,
      usuarioNroDeDocumentoX: data?.nroDocumento || null,
      usuarioSexo: data?.sexo || null,
      usuarioFechaDeNacimiento: data?.fechaNacimiento || null,
      rnhAgenteLugarId: data?.lugarId || null,
      rnhAgenteLugarVersion: data?.lugarVersion ?? null,
      rnhEstablecimientoEstructuraId: data?.establecimientoEstructuraId || null,
      rnhHospitalCod: data?.hospitalCod || null,
      rnhTipoComponenteCod: data?.tipoComponenteCod || null,
      rnhEstablecimientoCod: data?.componenteCod || null,
      rnhFuncionCod: data?.funcionCod || null,
      // El horario de ESTA asignación. Solo viaja cuando el agente tiene tipo de horario
      // "F" (fijo); con "R" o sin tipo, el modal manda null. Ver AsignarModal.
      rnhAgenteLugarHorarioId: data?.horarioId || null,
      rnhAgenteLugarCargo: data?.lugarCargo || null,
      rnhLugarPrincipal: data?.lugarPrincipal || null,
      rnhStatusAgenteCod: data?.lugarStatusCod || null,
    }
  }

  return respuestaDe(await axiosPost(body, credentials));
}
